export const marketingKey = {
    PROMO_CODE: 'promoCode0',
    PRICE_ADJUSTMENT: 'PriceAdjustment0',
    FINAL_PRICE: 'FinalPriceTotal',
    CODE_DESCRIPTION: 'CalculationCodeDescription0',
};

export const promotionType = {
    MANUAL: 'manual',
    AUTO: 'auto',
    NONE: 'none',
};